 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGH from '@/components/html/02_Copyrigh'
 import HTML01_TITLE_PA from '@/components/html/01_Title_Pa'
 import HTML03_DEDICATI from '@/components/html/03_Dedicati'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_LIST_OF from '@/components/html/05_List_of'
 import HTML06_ACKNOWLE from '@/components/html/06_Acknowle'
 import HTML07_INTRODUC from '@/components/html/07_Introduc'
 import HTML08_1__FROM from '@/components/html/08_1__From'
 import HTML09_2__THE_F from '@/components/html/09_2__The_F'
 import HTML10_3__THE_O from '@/components/html/10_3__The_O'
 import HTML11_4__HOW_L from '@/components/html/11_4__How_L'
 import HTML12_IN_GUISE from '@/components/html/12_In_Guise'
 import HTML13_ON_THE_R from '@/components/html/13_On_the_R'
 import HTML14_ABBREVIA from '@/components/html/14_Abbrevia'
 import HTML15_NOTES from '@/components/html/15_Notes'
 import HTML16_BIBLIOGR from '@/components/html/16_Bibliogr'
 import HTML17_INDEX from '@/components/html/17_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_List_of",
 			"name" : "html/05_List_of",
 			"component" : HTML05_LIST_OF
 		},
 		{
 			"path" : "/html/06_Acknowle",
 			"name" : "html/06_Acknowle",
 			"component" : HTML06_ACKNOWLE
 		},
 		{
 			"path" : "/html/07_Introduc",
 			"name" : "html/07_Introduc",
 			"component" : HTML07_INTRODUC
 		},
 		{
 			"path" : "/html/08_1__From",
 			"name" : "html/08_1__From",
 			"component" : HTML08_1__FROM
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js